<template>
  <div>
    <el-header height="50px">
      <sp-header  :profile="profile" :currentOrg="currentOrg" :init="init" />
    </el-header>
    <div class="sp-container">
      <sp-menu-group 
        style="overflow: visible !important;" 
        :menuWidth="['40px', '200px']" 
        :menuStatus.sync="status" 
        :class="{'is-open': status}">
          <sp-menu v-if="menus.length"  
            @select-id="getSelectId" 
            @page-config="getPageConfig" 
            router 
            :menus="menus" 
            height="50px" 
            pagePermissions 
            :menuStatus="status" 
            :select-id="selectId" />
      </sp-menu-group>
      <div class="sp-main" :style="{marginLeft:status ? '200px' : '40px'}">
        <router-view/>
      </div>
    </div>
    <el-footer height="auto">
      <sp-footer/>
    </el-footer>
  </div>
</template>

<script>
import spHeader from "./sp-header";
import spFooter from "./sp-footer";
import vm from '../../main.js'
export default {
  data() {
    return {
      status: true,
      selectId: "1",
      menus: [],
      profile: {},
      currentOrg: { id: "", name: "" },
      init: false
    };
  },
  components: {
    spHeader,
    spFooter
  },
  created() {
    this.getProfile();
  },
  computed: {
    pageConfig: {
      get: function () {
        return this.$store.state.pageConfig
      },
      set: function () {
      }
    }
  },
  // TODO 暂时处理办法
  // 如果balance.vue页面的权限按钮发生改变的话，一定！一定！一定！记得在这里更改，否则在没有点击信用额度页面时，无法赋值菜单权限，spfction.js报错会导致页面无法加载
  beforeRouteEnter (to, from, next) {
    if(to.fullPath == '/'){
      next(vm =>{
        vm.getPageConfig([{"id":201,"label":"搜索"},{"id":202,"label":"充值"}])
        sessionStorage.setItem('configs', JSON.stringify([{"id":201,"label":"搜索"},{"id":202,"label":"充值"}]))
      })
    } 
    else{ 
      next()
    }
  },
  methods: {
    //菜单选中的ID
    getSelectId(val) {
      this.selectId = sessionStorage.selectId = val;
      // console.log("选中的ID： " + val);
    },
    //获取页面权限
    getPageConfig(val) {
      this.pageConfig = val;
      // console.log("获取页面权限： " + JSON.stringify(val));
    },
    getProfile() {
      let _this = this;
      this.$request1
        .get(
          '/user/profile',
          {
            timeout: 1000,
            withCredentials: true,
            headers: {
              "content-type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(function(response) {
            _this.profile = response.data;
            if (_this.profile.currentOrg !== null) {
              if(_this.profile.menus){
                _this.menus = _this.profile.menus.menus;

                // _this.$route.path == '/nopermission' && _this.$router.push({path: '/'});
              }else {
                // _this.$router.push({path: '/nopermission'});
              }
              _this.currentOrg = _this.profile.currentOrg;
              return;
            }

          if (_this.currentOrg == null || _this.currentOrg.id === "") {
            _this.init = true;
            return;
          }
          
        })
        .catch(function(error) {
          console.log(error)
          // if (error.response.status == 401) {
          //   var r = '/login';
          //   window.location.href = r;
          // }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../static/iconfont/iconfont.css";
.sp-menu-group.crrut .side-nav {
  overflow: hidden;
}
.sp-main {
  transition: margin 0.3s;
  border-top: 1px solid #ddd;
  background-color: #f3f3f4;
  min-height: 93vh;
  min-height: calc(100vh - 109px);
  min-height: -webkit-calc(100vh - 109px);
  min-height: -moz-calc(100vh - 109px);
  .pay-success__page{
    width: 100%;
    min-height: 93vh;
    min-height: calc(100vh - 109px);
    min-height: -webkit-calc(100vh - 109px);
    min-height: -moz-calc(100vh - 109px);
  }
}
.sp-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/mainpage.vue